import CheckBoxGroup from 'components/ui/Form/OnboardingCheckBoxGroup/OnboardingCheckBoxGroup';
import {BusinessPartner} from 'types/api';

import styles from './OwnerForm.module.scss';

const assetsOwnerItems = [
    {
        label: 'No',
        value: 'no',
    },
    {
        label: (
            <span>
                Yes. <br /> The relevant information regarding the beneficial
                owner has to be obtained by filling in a separate form.
            </span>
        ),
        value: 'yes',
    },
];

interface IOwnerProps {
    activeBusinessPartner: BusinessPartner;
}

const OwnerForm = ({activeBusinessPartner}: IOwnerProps) => {
    return (
        <div className={styles.form}>
            <CheckBoxGroup
                defaultValue={
                    activeBusinessPartner?.gwgInfo?.assetsOwner ? 'yes' : 'no'
                }
                options={assetsOwnerItems}
                type="radio"
                label="Is a third person the beneficial owner of the assets booked under the above relationship?"
                name="gwgInfo.assetsOwner"
                variant="dark"
                size="large"
            />
        </div>
    );
};

export default OwnerForm;
